import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './AdminCourses.css';

const AdminCourses = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    price: '0.00',
    duration_hours: '0',
    level: 'iniciante',
    category: 'vendas',
    is_published: '0'
  });

  useEffect(() => {
    if (user?.role !== 'admin' && user?.role !== 'instructor') {
      navigate('/dashboard');
      return;
    }
    loadCourses();
  }, [user]);

  const loadCourses = async () => {
    try {
      const response = await api.get('/courses');
      const data = Array.isArray(response.data) ? response.data : [];
      setCourses(data);
    } catch (error) {
      console.error('Erro ao carregar cursos:', error);
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/courses', formData);
      alert('Curso criado com sucesso!');
      setShowModal(false);
      setFormData({
        title: '',
        description: '',
        price: '0.00',
        duration_hours: '0',
        level: 'iniciante',
        category: 'vendas',
        is_published: '0'
      });
      loadCourses();
    } catch (error) {
      alert(error.response?.data?.error || 'Erro ao criar curso');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este curso?')) {
      try {
        await api.delete(`/courses/${id}`);
        alert('Curso excluído!');
        loadCourses();
      } catch (error) {
        alert('Erro ao excluir curso');
      }
    }
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Carregando...</p>
      </div>
    );
  }

  return (
    <div className="admin-courses">
      <header className="admin-header">
        <div>
          <h1>Gerenciar Cursos</h1>
          <button onClick={() => navigate('/dashboard')} className="btn btn-secondary" style={{marginTop: '10px'}}>
            ← Voltar ao Dashboard
          </button>
        </div>
        <button onClick={() => setShowModal(true)} className="btn btn-primary">
          + Novo Curso
        </button>
      </header>

      <div className="courses-table">
        {courses.length === 0 ? (
          <div className="empty-state">
            <p>Nenhum curso cadastrado ainda.</p>
            <button onClick={() => setShowModal(true)} className="btn btn-primary">
              Criar Primeiro Curso
            </button>
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Título</th>
                <th>Categoria</th>
                <th>Preço</th>
                <th>Duração</th>
                <th>Publicado</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {courses.map((course) => (
                <tr key={course.id}>
                  <td>{course.title}</td>
                  <td>{course.category}</td>
                  <td>R$ {course.price}</td>
                  <td>{course.duration_hours}h</td>
                  <td>
                    <span className={`status-badge ${course.is_published ? 'status-published' : 'status-draft'}`}>
                      {course.is_published ? 'Sim' : 'Não'}
                    </span>
                  </td>
                  <td>
                    <button onClick={() => handleDelete(course.id)} className="btn-delete">
                      Excluir
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Novo Curso</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Título *</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  className="form-control"
                  placeholder="Ex: Técnicas de Vendas Consultivas"
                />
              </div>

              <div className="form-group">
                <label>Descrição *</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  required
                  rows="4"
                  className="form-control"
                  placeholder="Descreva o que o aluno vai aprender..."
                ></textarea>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Preço (R$)</label>
                  <input
                    type="number"
                    name="price"
                    value={formData.price}
                    onChange={handleChange}
                    step="0.01"
                    min="0"
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label>Duração (horas)</label>
                  <input
                    type="number"
                    name="duration_hours"
                    value={formData.duration_hours}
                    onChange={handleChange}
                    min="0"
                    className="form-control"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Nível</label>
                  <select
                    name="level"
                    value={formData.level}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="iniciante">Iniciante</option>
                    <option value="intermediario">Intermediário</option>
                    <option value="avancado">Avançado</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Categoria</label>
                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="vendas">Vendas</option>
                    <option value="empreendedorismo">Empreendedorismo</option>
                    <option value="marketing">Marketing</option>
                    <option value="gestao">Gestão</option>
                    <option value="produtividade">Produtividade</option>
                    <option value="lideranca">Liderança</option>
                    <option value="financeiro">Financeiro</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Publicar?</label>
                <select
                  name="is_published"
                  value={formData.is_published}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="0">Não (Rascunho)</option>
                  <option value="1">Sim (Publicado)</option>
                </select>
              </div>

              <div className="form-buttons">
                <button type="button" onClick={() => setShowModal(false)} className="btn btn-secondary">
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  Criar Curso
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminCourses;
